const E = "Authentication", R = "Braid", t = "Meeting Memory", G = "Chat", _ = "Stream", S = "Devices", c = "Effects SDK";
export {
  t as LOGGER_MEETING_MEMORY,
  E as LOGGER_SERVICE_AUTH,
  R as LOGGER_SERVICE_BRAID,
  G as LOGGER_SERVICE_CHAT,
  S as LOGGER_SERVICE_DEVICES,
  c as LOGGER_SERVICE_EFFECTS_SDK,
  _ as LOGGER_SERVICE_STREAM
};
